export default __webpack_public_path__ + "static/media/fourth.cb34143d.m4a";